import * as React from "react";
const SvgComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.33336 12.6433L15.9934 4.98242L17.1725 6.16076L8.33336 14.9999L3.03003 9.69659L4.20836 8.51826L8.33336 12.6433Z"
      fill="#0E867C"
    />
  </svg>
);
export default SvgComponent;
